export default __webpack_public_path__ + "static/media/Footer.027ada94.jpg";